import React from 'react';
import styled from 'styled-components';
import {LinkPropType, Link} from '../../Link';

type MenuLinkProps = LinkPropType & {
  active?: boolean;
  $textColor?: string;
  bg?: string;
};

const StyledLink = styled(Link)<MenuLinkProps>`
  color: ${props => (props.active ? '#1493BE' : '#000')};
  background: ${props => props.bg ?? 'initial'};
  color: ${props => props.$textColor ?? 'initial'};
  &:hover,
  &:focus,
  &:active {
    color: ${props => (props.$textColor ? `${props.$textColor} !important` : 'initial')};
  }
`;

export const MenuLink: React.FC<MenuLinkProps> = props => {
  // We need to pass 'active' conditionally
  const {active, ...rest} = props;
  return <StyledLink {...(active ? {active} : {})} {...rest} />;
};
